import { ActionTypes, SnackbarType } from 'features/SnackbarManager/types'

interface SnackbarState {
  snackbars: SnackbarType[]
}

const initialState: SnackbarState = {
  snackbars: []
}

export const SnackbarReducer = (state = initialState, action: ActionTypes): typeof initialState => {
  switch (action.type) {
    case 'SNACKBAR__ADD_SNACKBAR': {
      const newSnackbar = {
        ...action.snackbar,
        id: `${Date.now()}`
      }
      return {
        ...state,
        snackbars: [...state.snackbars, newSnackbar]
      }
    }

    case 'SNACKBAR__REMOVE_SNACKBAR': {
      return {
        ...state,
        snackbars: state.snackbars.filter(
          (snackbar) => snackbar.id !== action.id
        )
      }
    }
    default:
      return state
  }
}
